// extracted by mini-css-extract-plugin
module.exports = {"title":"privacy-module--title--bIvwE","root":"privacy-module--root--2cE2a"};